import { ref, computed } from 'vue';
import { useFingerprint } from './useFingerprint';
import { FraudResult, FraudDetectionComposable } from '../types';

export function useFraudDetection(): FraudDetectionComposable {
  const { signals, riskScore } = useFingerprint();
  const isChecking = ref(false);

  const fraudSignals = computed(() => {
    if (!signals.value) return {};
    
    return {
      vpn: signals.value.vpn || false,
      tor: signals.value.tor || false,
      proxy: signals.value.proxy || false
    };
  });

  const checkFraud = async (data: any = {}): Promise<FraudResult> => {
    isChecking.value = true;
    
    try {
      // Determine fraud based on risk score and signals
      const currentRiskScore = riskScore.value;
      const block = currentRiskScore > 0.8 || signals.value?.tor || false;
      const challenge = currentRiskScore > 0.5 && currentRiskScore <= 0.8;
      const allow = currentRiskScore <= 0.5;
      
      const reasons: string[] = [];
      
      if (signals.value?.vpn) reasons.push('VPN detected');
      if (signals.value?.tor) reasons.push('Tor browser detected');
      if (signals.value?.proxy) reasons.push('Proxy detected');
      if (currentRiskScore > 0.7) reasons.push('High risk score');
      
      // Check transaction-specific risks
      if (data.amount && data.amount > 1000) {
        if (currentRiskScore > 0.3) {
          reasons.push('High-value transaction with elevated risk');
        }
      }

      return {
        block,
        challenge,
        allow,
        riskScore: currentRiskScore,
        reasons
      };
    } finally {
      isChecking.value = false;
    }
  };

  return {
    checkFraud,
    fraudSignals,
    isChecking
  };
}